import PropTypes from 'prop-types';
import React from 'react';

import { ButtonsMenu } from './ButtonsMenu';
import { FilterMenu } from './FilterMenu';

export function CollectionsBar({ theme, ...rest }) {
    return theme.filterMode === 'filter' ? (
        <FilterMenu theme={theme} {...rest} />
    ) : (
        <ButtonsMenu theme={theme} {...rest} />
    );
}

CollectionsBar.propTypes = {
    items: PropTypes.array.isRequired,
    interactive: PropTypes.bool,
    activeCollectionId: PropTypes.string,
    theme: PropTypes.object.isRequired,
    onSelect: PropTypes.func,
};
